import script from "./login.vue?vue&type=script&lang=ts&setup=true"
export * from "./login.vue?vue&type=script&lang=ts&setup=true"

import "./login.vue?vue&type=style&index=0&id=3fc1b80a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc1b80a"]])

export default __exports__